import React, { useEffect, useState } from 'react';
import { format, formatDistance, isToday } from 'date-fns';
import { useDispatch } from 'react-redux';
import { useHistory, useParams, withRouter } from 'react-router';
import { ReducerKeys } from 'redux/config';
import withReducer from 'redux/withReducer';
import {
  ChatPageContainer,
  Chatgroups,
  Conversation,
  ChatsNotFound,
} from 'components/compounds/Chat';
import { IChatPageParams } from './types';
import NavigationConfig from 'navigation/config';

const ChatPage = () => {
  const dispatch = useDispatch();
  const { chatGuid } = useParams<IChatPageParams>();
  const history = useHistory();

  return (
    <div>
      <ChatPageContainer
        chatgroups={
          <Chatgroups
            onContactSelected={(id) => {
              history.push(NavigationConfig.chatPage({ chatGuid: id }).path);
            }}
            selectedChatgroup={chatGuid ?? null}
          />
        }
        conversation={
          chatGuid ? <Conversation chatgroupId={chatGuid} /> : <ChatsNotFound />
        }
      />
    </div>
  );
};

const Page = withRouter(ChatPage);
export default withReducer(ReducerKeys.CHAT_REDUCER)(Page);
